
import { mapGetters } from "vuex"
import {
	PhBook,
	PhLayout,
	PhDiamondsFour,
	PhArchiveTray,
	PhExport,
	PhFilePlus,
	PhBuildings,
	PhPen,
	PhUserList,
	PhFunnelSimple,
	PhSyringe,
	PhFileSearch,
	PhUserCircle,
	PhListDashes,
	PhGearSix,
	PhUserFocus,
	PhCalculator,
	PhFaders,
	PhMoney,
	PhArrowRight,
	PhArrowsClockwise,
	PhListNumbers,
	PhAddressBook,
	PhBriefcase,
	PhHandshake,
	PhChartLine,
	PhHourglassMedium,
	PhTreeStructure,
} from "phosphor-vue"
export default {
	data() {
		return {}
	},
	components: {
		PhBook,
		PhLayout,
		PhDiamondsFour,
		PhArchiveTray,
		PhExport,
		PhFilePlus,
		PhBuildings,
		PhPen,
		PhUserList,
		PhFunnelSimple,
		PhSyringe,
		PhFileSearch,
		PhUserCircle,
		PhListDashes,
		PhGearSix,
		PhUserFocus,
		PhCalculator,
		PhFaders,
		PhMoney,
		PhArrowRight,
		PhArrowsClockwise,
		PhListNumbers,
		PhAddressBook,
		PhBriefcase,
		PhHandshake,
		PhChartLine,
		PhHourglassMedium,
		PhTreeStructure,
	},
	computed: {
		...mapGetters({
			user: "user",
		}),
	},
}
